'use client';

import 'BomdisoftComponents/layout/styles.css';
import { useLayoutState } from 'BomdisoftComponents/layout/context';
import { LayoutDrawerResize } from 'BomdisoftComponents/layout/drawer-resize';
import { type CSSProperties, type ReactNode } from 'react';

export const LayoutDrawerSlot = ({ children, drawerId, resizable = true }: { children: ReactNode; drawerId: string; resizable?: boolean }) => {
  const drawerState = useLayoutState(state => state.drawers[drawerId]);
  const open = drawerState?.open ?? false;
  const width = drawerState?.width ?? 0;

  return (
    <div className='bomdisoft-layout-drawer-slot' data-open={open ? '' : undefined} style={{ '--slot-width': `${width}px` } as CSSProperties}>
      {open && resizable && <LayoutDrawerResize drawerId={drawerId} />}
      <div className='bomdisoft-layout-drawer-content' data-hidden={open ? undefined : ''}>
        {children}
      </div>
    </div>
  );
};
